import React, { Component } from "react";
import ReactGA from "react-ga4";
export default class BuyTicket extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick() {
    ReactGA.event({
      category: "aastaloos_2023",
      action: "click",
      label: "buy ticket",
    });
  }
  render() {
    const { language } = this.props;
    return (
      <div className="buyTicket">
        <a
          className="button button--golden"
          href={
            language === "et"
              ? "https://www.eestiloto.ee/et/vikinglotto"
              : "https://www.eestiloto.ee/ru/vikinglotto"
          }
          target="_blank" rel="noreferrer"
          onClick={() => this.handleClick()}
        >
         
          <span>{language === "et" ? "OSTAN PILETI" : "Купить билет"}</span>
        </a>
      </div>
    );
  }
}
